import toast from 'react-hot-toast'

import type { IToast } from '@/interfaces'

const activeToasts = new Set<string>()

const style = {
  backgroundColor: 'rgb(255 255 255 / 0.9)',
  backdropFilter: 'blur(2rem)',
  fontFamily: 'var(--font-family-main), sans-serif',
  fontSize: '1.5rem',
  fontWeight: '500',
  color: '#000',
  lineHeight: '1.3',
  fill: '#000',
  marginBottom: '2rem',
  animation: 'slideIn 0.3s ease-out',
  padding: '1.5rem 2rem',
  borderRadius: '0.8rem',
}

const successStyle = {
  ...style,
  backgroundColor: 'rgba(245,254,249,255)',
  color: 'rgba(4,118,71,255)',
  fill: 'rgba(4,118,71,255)',
  border: '1px solid rgba(117,224,167,255)',
}

const errorStyle = {
  ...style,
  backgroundColor: 'rgba(255,251,250,255)',
  color: 'rgba(180,36,25,255)',
  fill: 'rgba(180,36,25,255)',
  border: '1px solid rgba(180,36,25,255)',
}

toast.dismiss()
const toastStyles = document.createElement('style')
toastStyles.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`
document.head.append(toastStyles)

const persistentToast = (msg: string, type: 'success' | 'error' | 'loading') => {
  let toastId: string

  const show = () => {
    toast.dismiss()
    toastId = toast[type](msg, {
      position: 'bottom-right',
      duration: Number.POSITIVE_INFINITY,
      style: type === 'success' ? successStyle : type === 'error' ? errorStyle : style,
    })
  }

  const hide = () => {
    toast.dismiss(toastId)
  }

  return { show, hide }
}

// toast
const customToast: IToast = (msg, type, promise, duration = 3000) => {
  if (activeToasts.has(msg)) {
    return
  }

  activeToasts.add(msg)

  const removeToast = () => {
    setTimeout(() => {
      activeToasts.delete(msg)
    }, duration)
  }

  type === 'promise'
    ? toast.promise(
        promise,
        {
          loading: 'Loading',
          success: 'Got the data',
          error: 'Error when fetching',
        },
        {
          position: 'bottom-right',
          style,
        },
      )
    : toast[type](msg, {
        position: 'bottom-right',
        duration,
        style: type === 'success' ? successStyle : type === 'error' ? errorStyle : style,
        iconTheme:
          type === 'success'
            ? { primary: 'rgba(14,122,76,255)', secondary: 'rgba(245,254,249,255)' }
            : type === 'error'
              ? { primary: 'rgba(180,36,25,255)', secondary: 'rgba(255,251,250,255)' }
              : undefined,
      })

  if (type !== 'promise') {
    removeToast()
  }
}

// toast hook
const useToast = () => {
  return { customToast, persistentToast }
}

export { customToast, persistentToast, useToast }
